export const initSearchGuard = () => {
  const searchForm = document.querySelector('.site-header__search');
  const searchInput = searchForm?.querySelector('input[type="search"]');

  if (!searchForm || !searchInput) {
    return;
  }

  searchForm.addEventListener('submit', (event) => {
    if (searchInput.value.trim() !== '') {
      return;
    }

    event.preventDefault();
    searchInput.focus();
  });
};